<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editUpdateProcedure"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card *ngIf="p2UpdateProcedureKeyno === '0'" ttHeading="h_update_procedure_new">
            <ng-container *ngTemplateOutlet="editUpdateProcedure"></ng-container>
        </tt-card>

        <tt-card *ngIf="p2UpdateProcedureKeyno !== '0'" ttHeading="h_update_procedure_edit">
            <ng-container *ngTemplateOutlet="editUpdateProcedure"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editUpdateProcedure>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="p2_updateprocedure_keyno" [ttModel]="page.p2_updateprocedure_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="proc_name" [(ttModel)]="page.proc_name" ttRequired></tt-input>
        <tt-checkbox ttLabel="is_like" [(ttModel)]="page.is_like"></tt-checkbox>
        <tt-checkbox ttLabel="but_not_like" [(ttModel)]="page.but_not_like"></tt-checkbox>
        <tt-checkbox ttLabel="is_equal_to" [(ttModel)]="page.is_equal_to"></tt-checkbox>
        <tt-checkbox ttLabel="but_not_equal_to" [(ttModel)]="page.but_not_equal_to"></tt-checkbox>
        <tt-datetime ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttMinutePrecision="1" ttReadonly></tt-datetime>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>
